import * as React from "react";

function AppDevelopmentSvg(props) {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width={40} height={40} viewBox="0 0 40 40" {...props}>
      <g fill="none" stroke="#fff" strokeWidth={2}>
        <rect width={24} height={36} x={8} y={2} rx={4} />
        <circle cx={20} cy={30} r={2} />
      </g>
    </svg>
  );
}

export default AppDevelopmentSvg;
